const UPDATES = [
  { date: '2026-07-30', title: '香蕉视频热播剧《星光之城》更新至第28集', tag: '剧集更新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-29', title: '蜜桃视频上线多部院线新片，暑期档大片陆续登场', tag: '新片上线', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '2026-07-28', title: '西瓜视频综艺《欢乐大本营》新一季开播', tag: '综艺开播', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '2026-07-27', title: '樱花视频七月新番专题页面全面更新', tag: '专题更新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-26', title: '糖豆视频纪录片《大地之脉》上线，评分9.2', tag: '精品推荐', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '2026-07-25', title: '樱桃视频推出暑期特惠观影活动', tag: '平台活动', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '2026-07-24', title: '蘑菇视频经典老片修复版专区正式开放', tag: '专区上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-23', title: '各大平台同步上线4K超清画质选项', tag: '体验升级', tagColor: 'bg-accent-100 text-accent-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          各平台最新更新与热门快讯
        </p>
        <div className="max-w-2xl mx-auto">
          {UPDATES.map((item, idx) => (
            <div key={idx} className="relative pl-8 pb-6 last:pb-0">
              {/* Timeline line */}
              {idx < UPDATES.length - 1 && (
                <div className="absolute left-[11px] top-6 bottom-0 w-0.5 bg-background-200"></div>
              )}
              {/* Dot */}
              <div className={`absolute left-0 top-1 w-[22px] h-[22px] rounded-full border-[3px] border-background-100 ${
                idx === 0 ? 'bg-primary-500' :
                idx < 3 ? 'bg-accent-500' : 'bg-background-300'
              }`}></div>
              <div className="ml-1">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mt-1 leading-relaxed">
                  {item.title}
                </h3>
                <span className={`inline-block mt-1.5 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}